import Link from 'next/link';

import Arrow from 'icons/arrow.svg';
import classes from './BackLink.module.css';

const BackLink = ({ href, onClick }: { href?: string; onClick?: () => void }) => {
  if (href) {
    return (
      <Link href={href} onClick={onClick}>
        <a className={classes.backLink}>
          <Arrow className={classes.backArrow} />
          Tillbaka
        </a>
      </Link>
    );
  }

  return (
    <button type="button" className={classes.backLink} onClick={onClick}>
      <Arrow className={classes.backArrow} />
      Tillbaka
    </button>
  );
};

export default BackLink;
